import { useEffect, useRef, useState } from 'react'
import { Icon } from '../icons'

/**
 * O aviso de cordialidade. Nunca bloqueia: as três saídas enviam, e Esc volta ao composer com
 * o rascunho intacto. Enter envia o que está na caixa (a sugestão, ou a versão editada).
 *
 * Sem sugestão (a reescrita falhou ou mexeu em algum fato), a caixa começa com o original para
 * a pessoa ajustar ali mesmo.
 */
export function CordialityPopup({
  reason,
  original,
  suggestion,
  onSend,
  onCancel,
}: {
  reason: string
  original: string
  suggestion: string | null
  onSend: (text: string) => void
  onCancel: () => void
}) {
  const start = suggestion ?? original
  const [text, setText] = useState(start)
  const edited = text.trim() !== start.trim()
  const ref = useRef<HTMLTextAreaElement>(null)
  useEffect(() => { ref.current?.focus(); ref.current?.setSelectionRange(0, 0) }, [])

  return (
    <>
      <div className="modal-back" onClick={onCancel} />
      <div
        className="modal cordial"
        role="dialog"
        aria-modal="true"
        aria-label="Revisar o tom antes de enviar"
        onKeyDown={(e) => {
          if (e.key === 'Escape') { e.preventDefault(); onCancel() }
          if (e.key === 'Enter' && !e.shiftKey && text.trim()) { e.preventDefault(); onSend(text.trim()) }
        }}
      >
        <div className="modal-h">
          <Icon name="smile" size={15} />
          {reason}
          <button className="icon-btn" onClick={onCancel} aria-label="Voltar sem enviar">
            <Icon name="x" size={14} />
          </button>
        </div>
        <div className="modal-b">
          <div className="fld">
            <span>Original</span>
            <div className="cordial-orig">{original}</div>
          </div>
          <label className="fld">
            <span>{suggestion ? (edited ? 'Sugestão (editada)' : 'Sugestão') : 'Sem sugestão segura — ajuste se quiser'}</span>
            <textarea ref={ref} rows={5} value={text} onChange={(e) => setText(e.target.value)} />
          </label>
          <div className="modal-f">
            <button className="btn ghost" onClick={() => onSend(original)}>Enviar original</button>
            <button className="btn sec" disabled={!edited || !text.trim()} title={edited ? undefined : 'Edite o texto acima'} onClick={() => onSend(text.trim())}>
              Editar e enviar
            </button>
            {suggestion && (
              <button className="btn pri" disabled={edited} title="Enter" onClick={() => onSend(suggestion)}>
                Enviar sugestão
              </button>
            )}
          </div>
          <p className="modal-note">Enter envia o texto da caixa · Esc volta sem enviar</p>
        </div>
      </div>
    </>
  )
}
